// extracted by mini-css-extract-plugin
export default {"wrapper":"U7-z"};